import React from 'react';
import NorbergOlssonButton from './NorbergOlssonButton';
import VHSButton from './VHSButton';
import { makeActivatableToolButton } from './ActivatableToolButton';
import VerticalFlipButton from './VerticalFlipButton';
import HorizontalFlipButton from './HorizontalFlipButton';
import { makeFixedAngleRotateButton } from './FixedAngleRotateButton';
import NegativeColorButton from './NegativeColorButton';
import FullScreenButton from './FullScreenButton';
import ZoomWithPercentButton from './ZoomWithPercentButton';
import WWWCGroup from './WWWCGroup';
import CropToolButton from './CropToolButton';
import ProcessingListButton from './ProcessingListButton';
import PicoxiaAnalysisButton from './PicoxiaAnalysisButton';
import DIButton from './DIButton';
import TPLOButton from './TPLOButton';
import VpopProButton from './VpopProButton';
import AnnotationsDisplaySwitchButton from 'app/components/ToolsBar/AnnotationsDisplaySwitchButton';
import FreeRotationToolButton from './FreeRotationToolButton';

const ContentForwarder = ({ content }: { content: React.ReactNode }) => content;

export const STATELESS_TOOLS_BUTTON_MAP = {
  // Below are buttons that apply their behavior on click and do not activate a specific tool.
  NegativeColor: NegativeColorButton,
  FullScreen: FullScreenButton,
  FullSizeConfiguration: ContentForwarder,
  RealSizeMeasurementCalibration: ContentForwarder,
  Processing: ProcessingListButton,
  PicoxiaAnalysis: PicoxiaAnalysisButton,
  AnnotationsDisplaySwitch: AnnotationsDisplaySwitchButton,
  VpopPro: VpopProButton,
  Negato: ContentForwarder,
  VerticalFlip: VerticalFlipButton,
  HorizontalFlip: HorizontalFlipButton,
  ClockwiseRotation: makeFixedAngleRotateButton(
    90,
    <i className="svg-icon clockwise-rotation" />,
    'tools.rotate_right.tooltip'
  ),
  CounterClockwiseRotation: makeFixedAngleRotateButton(
    -90,
    <i className="svg-icon counter-clockwise-rotation" />,
    'tools.rotate_left.tooltip'
  ),
  FreeRotation: FreeRotationToolButton,
} as const;
Object.freeze(STATELESS_TOOLS_BUTTON_MAP);

export const STATEFUL_TOOLS_BUTTON_MAP = {
  // Image manipulation tool
  Pan: makeActivatableToolButton(<i className="svg-icon pan" />, 'tools.pan.tooltip'),
  Crop: CropToolButton,
  Magnify: makeActivatableToolButton(<i className="svg-icon magnify" />, 'tools.magnify.tooltip'),
  ZoomMouseWheel: ZoomWithPercentButton,
  WWWC: WWWCGroup,
  Eraser: makeActivatableToolButton(<i className="svg-icon eraser" />, 'tools.erase.tooltip'),

  // Annotations tools
  LeftMarker: makeActivatableToolButton(
    <i className="svg-icon left-marker" />,
    'tools.left_marker.tooltip'
  ),
  RightMarker: makeActivatableToolButton(
    <i className="svg-icon right-marker" />,
    'tools.right_marker.tooltip'
  ),
  TextMarker: makeActivatableToolButton(
    <i className="svg-icon text-marker" />,
    'tools.text_annotate.tooltip'
  ),
  ArrowAnnotate: makeActivatableToolButton(
    <i className="svg-icon arrow-annotate" />,
    'tools.arrow_annotate.tooltip'
  ),

  // Measurement tools
  Length: makeActivatableToolButton(<i className="svg-icon length" />, 'tools.length.tooltip'),
  CircleRadius: makeActivatableToolButton(
    <i className="svg-icon circle-radius" />,
    'tools.circle_radius.tooltip'
  ),
  Angle: makeActivatableToolButton(<i className="svg-icon angle" />, 'tools.angle.tooltip'),
  ExternalAngle: makeActivatableToolButton(
    <i className="svg-icon external-angle" />,
    'tools.external_angle.tooltip'
  ),
  TPLO: TPLOButton,
  DistractionIndex: DIButton,
  NorbergOlsson: NorbergOlssonButton,
  VHS: VHSButton,
} as const;
Object.freeze(STATEFUL_TOOLS_BUTTON_MAP);
